// get fetch with xsrf token 
export async function xFetch(url) {
    if (document.cookie != null) {
        const xsrfToken = document.cookie
            .split("; ")
            .find(row => row.startsWith("XSRF-TOKEN="));

        if (xsrfToken != null && xsrfToken.length > 0 && xsrfToken.split("=").length > 1) {
            const authToken = xsrfToken.split("=")[1];

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    "X-XSRF-TOKEN": authToken
                },
            });



            if (response.status == 200) {

                const data = await response.json();
                return { data: data, error: null };

            } else if (response.status == 204) {
                // 204 No Content- null was returned in the data set
                return { data: null, error: null };

            } else if (response.status == 401) {

                return { data: null, error: 'Unauthorized' };

            } else {
                return { data: null, error: 'Error' };
            }
        }

    }
    return null;
}

export async function xPost(url, postData, dontRecurse) {
    if (document.cookie != null) {
        const xsrfToken = document.cookie
            .split("; ")
            .find(row => row.startsWith("XSRF-TOKEN="));

        if (xsrfToken != null && xsrfToken.length > 0 && xsrfToken.split("=").length > 1) {
            const authToken = xsrfToken.split("=")[1];

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    "X-XSRF-TOKEN": authToken
                },
                body: JSON.stringify(postData)
            });


            if (response.status == 200) {

                const data = await response.json();
                return { data: data, error: null };

            } else if (response.status == 204) {
                // 204 No Content- null was returned in the data set
                return { data: null, error: null };

            } else if (response.status == 401) {

                document.location='/?unauthorized=1'
                return { data: null, error: 'Unauthorized' };

            } else if (response.status == 400) {
                // only the first time we come through and get a 400, which is likely the XSRF token being
                // stale (perhaps a server restart), try and clear and get a new token, and try again
                if (!dontRecurse) {
                    document.cookie = 'XSRF-TOKEN=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    await fetch("/api/site/GetXRF");
                    return await xPost(url, postData, true);
                }
                return { data: null, error: 'BadRequest' };

            } else {
                return { data: null, error: 'Error' };
            }
        }


    }
    return { data: null, error: 'ErrorNoAntiForgeryToken' };
}

export function jsonParse(jsonString) {
    let result = null;
    try {
        result = JSON.parse(jsonString);
    } catch {
        throw "Invalid JSON string. " + jsonString;
    }
    return result;
}

export function urlEncodeText(text) {
    // change spaces to hyphens, and then remove anything that isn't a letter, number or hyphen
    return text.trim().toUpperCase().replace(/\s/g, "-").replace(/[^A-Z0-9\-]/g, "").replace(/\-+/g, "-");
}

export function toGMT(timeStr) {
    var time = new Date(timeStr);
    return new Date(Date.UTC(time.getFullYear(), time.getMonth(), time.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()));
}

export function getSecondsToTime(timeStr, browserGMT, systemSecondsToCloseDelta) {
    var time = new Date(timeStr);
    var closeTimeUtc = new Date(Date.UTC(time.getFullYear(), time.getMonth(), time.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()));
    var currentTimeUtc = browserGMT;

    return Math.floor((closeTimeUtc - currentTimeUtc) / 1000) + systemSecondsToCloseDelta;
}


// given a time, the number of seconds the servers thinks until the time, and the browser's GMT,
// compute the delta between the system and the browser
export function computeSystemTimeDifference(time, secondsToTime, browserGMT) {
    let localSecondsToTime = getSecondsToTime(time, browserGMT, 0);
    // this will determine how many seconds different the browser is from the system
    // we will add it back on the computation of the time to close in order to match the
    // system clock more closely, if not exactly
    return secondsToTime - localSecondsToTime;
}

export function validateEmail(value) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
}

export function captchaKey() {
    return "6Lfd9PYlAAAAAIW9GltGTRXBIPkkG0qILNWoDGN7";
}